import { useRef, useState, useEffect } from 'react';
import { SelectButton, PopoverSheet } from 'reaxl';
import { jsxs, jsx } from 'react/jsx-runtime';
function SelectButtonWrapper(_ref) {
  let {
    analyticProps,
    buttonLabel,
    children,
    className,
    disabled,
    heading,
    position,
    primaryLabel,
    secondaryLabel,
    containerElement,
    hideCTA,
    inputCompletedState,
    onClick = () => {},
    onSupportingLinkClick = () => {},
    isSupportingLinkClicked,
    ...rest
  } = _ref;
  const buttonRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const clickHandler = () => {
    setIsActive(!isActive);
    onSupportingLinkClick(false);
    onClick();
  };
  useEffect(() => {
    if (isSupportingLinkClicked) {
      setIsActive(false);
    }
  }, [isSupportingLinkClicked, setIsActive]);
  const handlePopoverClick = () => {
    setIsActive(false);
    onSupportingLinkClick(false);
  };
  return /*#__PURE__*/jsxs("div", {
    className: "position-relative",
    children: [/*#__PURE__*/jsx(SelectButton, {
      ref: buttonRef,
      disabled: disabled,
      onClick: clickHandler,
      isActive: isActive,
      primaryLabel: primaryLabel,
      secondaryLabel: secondaryLabel,
      boldSecondaryLabel: false,
      inputCompletedState: inputCompletedState,
      ...rest
    }), /*#__PURE__*/jsx(PopoverSheet, {
      show: isActive,
      onClick: handlePopoverClick,
      heading: heading,
      buttonLabel: buttonLabel,
      className: className,
      containerElement: containerElement,
      position: position,
      hideCTA: hideCTA,
      children: children
    })]
  });
}
export { SelectButtonWrapper as default };
